export default __webpack_public_path__ + "static/media/slt4-min.2c7b238e.jpg";